module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-light-gray-e1c86d11e48a31a18f04bef974ef113e.png";